import * as React from 'react';

import BaseButton from '@/components/elements/Button/BaseButton';
import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';
import { defaultTheme } from '@/utility/theme';

import { ButtonWrapper, Container, Notice, Title } from './style';

interface CpConfirmModalProps extends ModalBasicProps {
  title: string;
  type: string;
  action: (type: string) => void;
}

const CpConfirmModal: React.FC<CpConfirmModalProps> = ({
  isOpen,
  handleClose,
  title,
  type,
  action,
}) => {
  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={() => handleClose()}
      backgroundColor={defaultTheme.background.white}
    >
      <Container>
        <Title data-testid="title">{title}</Title>
        <ButtonWrapper data-testid="button">
          <BaseButton
            size="m"
            bgColor="primary"
            radius="l"
            width={['100%', '320px', '320px', '320px']}
            height="56px"
            fontWeight="bold"
            onClick={() => {
              action(type);
            }}
          >
            エントリーする
          </BaseButton>
        </ButtonWrapper>
        <Notice data-testid="notice">
          ・一度エントリーすると、取り消しはできません
          <br />
          ・一度エントリーすると、別のプランへの変更はできません
        </Notice>
      </Container>
    </ModalBase>
  );
};

export default CpConfirmModal;
